import { webApi } from '@/shared/api/WebApi';
import type { JobViewsData } from '@/lib/types/Job';

/**
 * Job API endpoints.
 * Static class for consistent naming and namespacing.
 */
export class JobApi {
  /**
   * Fetch all jobs for a customer.
   * GET /v1/job?cId={cId}
   */
  static async getJobs(cId: number): Promise<JobViewsData> {
    return webApi.get<JobViewsData>('job', { cId });
  }
}
